import { hasWindow, isiOS } from '../../utils/browser';
import { PushSubscriptions, PushSubscriptionWireCategory } from './types';

const PUSH_CATEGORY_TO_SETTING = {
  note: 'note',
  comment_reply: 'commentReply',
  watcher: 'watcher',
  mention: 'mention',
  favourite: 'favourite',
  favourite_milestone: 'favouriteMilestone',
} as const satisfies Record<PushSubscriptionWireCategory, keyof PushSubscriptions>;

export function supportsWebPush() {
  if (!hasWindow()) {
    return false;
  }

  return (
    window.isSecureContext &&
    'serviceWorker' in navigator &&
    'Notification' in window &&
    'PushManager' in window
  );
}

export function supportsDesktopWebPush(isMobile: boolean) {
  return supportsWebPush() && !isMobile && !isiOS();
}

export function isPushCategoryEnabled(
  subscriptions: PushSubscriptions,
  pushCategory?: PushSubscriptionWireCategory | null
) {
  if (!pushCategory) {
    return false;
  }

  const settingKey = PUSH_CATEGORY_TO_SETTING[pushCategory];
  return !!subscriptions[settingKey];
}
